export const semanticTokens = {
  colors: {
    primary: {
      solid: { value: '{colors.mint.500}' },
      contrast: { value: '{colors.mint.100}' },
      fg: { value: '{colors.mint.700}' },
      muted: { value: '{colors.mint.100}' },
      subtle: { value: '{colors.mint.200}' },
      emphasized: { value: '{colors.mint.300}' },
      focusRing: { value: '{colors.mint.400}' },
    },
    positive: {
      solid: { value: '{colors.lightning.500}' },
      contrast: { value: '{colors.lightning.100}' },
      fg: { value: '{colors.lightning.700}' },
      muted: { value: '{colors.lightning.100}' },
      subtle: { value: '{colors.lightning.200}' },
      emphasized: { value: '{colors.lightning.300}' },
      focusRing: { value: '{colors.lightning.400}' },
    },
    neutral: {
      solid: { value: '{colors.fog.500}' },
      contrast: { value: '{colors.fog.100}' },
      fg: { value: '{colors.fog.700}' },
      muted: { value: '{colors.fog.100}' },
      subtle: { value: '{colors.fog.200}' },
      emphasized: { value: '{colors.fog.300}' },
      focusRing: { value: '{colors.fog.400}' },
    },
    alert: {
      solid: { value: '{colors.solar.500}' },
      contrast: { value: '{colors.solar.100}' },
      fg: { value: '{colors.solar.700}' },
      muted: { value: '{colors.solar.100}' },
      subtle: { value: '{colors.solar.200}' },
      emphasized: { value: '{colors.solar.300}' },
      focusRing: { value: '{colors.solar.400}' },
    },
    error: {
      solid: { value: '{colors.dusk.500}' },
      contrast: { value: '{colors.dusk.100}' },
      fg: { value: '{colors.dusk.700}' },
      muted: { value: '{colors.dusk.100}' },
      subtle: { value: '{colors.dusk.200}' },
      emphasized: { value: '{colors.dusk.300}' },
      focusRing: { value: '{colors.dusk.400}' },
    },
  },
};
